import pendaftaranKependudukanApi from '../../../services/form/pendaftaranKependudukanApi'

const state = {

}

const mutations = {

}

const actions = {
	async storeFormPendaftaranKependudukan({ getters }, data) {
		let token = getters.getAuthService.token
		return await pendaftaranKependudukanApi.storeFormPendaftaranKependudukan(token, data)
	},
	async updateFormPendaftaranKependudukan({ getters }, data) {
		let token = getters.getAuthService.token
		return await pendaftaranKependudukanApi.updateFormPendaftaranKependudukan(token, data.id, data.form)
	},
	async fetchFormPendaftaranKependudukanJenisPermohonan({ getters }) {
		let token = getters.getAuthService.token
		return await pendaftaranKependudukanApi.fetchFormPendaftaranKependudukanJenisPermohonan(token)
	},
	formatJenisPermohonan({ getters }, data) {
		let jenis = []

		data.forEach(e => {

			jenis.push({
				id_jenis_permohonan: e.id_jenis_permohonan,
				nama: e.nama
			})
			// console.log(e.nama)

			if (e.child) {
				e.child.forEach(f => {

					jenis.push({
						id_jenis_permohonan: f.id_jenis_permohonan,
						nama: e.nama + ' - ' + f.nama
					})
					// console.log(e.nama+' - '+f.nama)
					if (f.child) {
						f.child.forEach(g => {

							jenis.push({
								id_jenis_permohonan: g.id_jenis_permohonan,
								nama: e.nama + ' - ' + f.nama + ' - ' + g.nama
							})
							// console.log(e.nama+' - '+f.nama+' - '+g.nama)


						})
					}
				})
			}
		})

		return jenis
	},
	async cetakFormPendaftaranKependudukanByPermohonan({ getters }, id) { // id data permohonan
		let token = getters.getAuthService.token
		return await pendaftaranKependudukanApi.cetakFormPendaftaranKependudukanByPermohonan(token, id)
	},
	async cetakFormPendaftaranKependudukan({ getters }, id) {
		let token = getters.getAuthService.token
		return await pendaftaranKependudukanApi.cetakFormPendaftaranKependudukan(token, id)
	}
}

const getters = {

}

export default {
	state,
	mutations,
	actions,
	getters
}